import React, { useState } from 'react';
import {
    List,
    ListItemButton,
    ListItemText,
    Collapse
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import bot from '../../assets/images/happy.png'
import Lastmenu from './Lastmenu';

const faqData = [
    {
        question: "What fertility services are available at Hegde Fertility?",
        answer: "We offer services including IVF, IUI, fertility preservation, egg/sperm donation, genetic testing, and fertility surgeries."
    },
    {
        question: "What technologies does Hegde Fertility use for treatments?",
        answer: "We are equipped with state-of-the-art IVF labs, advanced ultrasound imaging, embryo freezing (vitrification) technology, and laser-assisted hatching."
    },
    {
        question: "Are your fertility labs accredited?",
        answer: "Yes, our labs meet the highest standards of quality control and are certified for best practices in fertility treatment."
    },
    {
        question: "Do you provide support services like counseling or nutrition advice?",
        answer: "Yes, we offer fertility counseling, psychological support, nutritional guidance, and wellness programs for our patients."
    }
];

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const [time] = useState(new Date());

    const handleToggle = (index) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    return (
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
        <div className="frame1 animated-frame" data-skip-scroll>
        <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px"}}>Frequently Asked Questions</h2>
            <List component="nav" sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {faqData.map((item, index) => (
                    <div key={index}>
                        <ListItemButton onClick={() => handleToggle(index)}>
                            <ListItemText primary={item.question} />
                            {openIndex === index ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary={item.answer} />
                                </ListItemButton>
                            </List>
                        </Collapse>
                    </div>
                ))}
            </List>
        </div>
        <Lastmenu />
        </>
    );
};

export default FAQs;
